import { render, staticRenderFns } from "./k2Input.vue?vue&type=template&id=a420b392"
import script from "./k2Input.vue?vue&type=script&lang=js"
export * from "./k2Input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports